"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indianred = "#CD5C5C";
exports.lightcoral = "#F08080";
exports.salmon = "#FA8072";
exports.darksalmon = "#E9967A";
exports.lightsalmon = "#FFA07A";
exports.crimson = "#DC143C";
exports.red = "#FF0000";
exports.firebrick = "#B22222";
exports.darkred = "#8B0000";
exports.pink = "#FFC0CB";
exports.lightpink = "#FFB6C1";
exports.hotpink = "#FF69B4";
exports.deeppink = "#FF1493";
exports.mediumvioletred = "#C71585";
exports.palevioletred = "#DB7093";
exports.coral = "#FF7F50";
exports.tomato = "#FF6347";
exports.orangered = "#FF4500";
exports.darkorange = "#FF8C00";
exports.orange = "#FFA500";
exports.gold = "#FFD700";
exports.yellow = "#FFFF00";
exports.lightyellow = "#FFFFE0";
exports.lemonchiffon = "#FFFACD";
exports.lightgoldenrodyellow = "#FAFAD2";
exports.papayawhip = "#FFEFD5";
exports.moccasin = "#FFE4B5";
exports.peachpuff = "#FFDAB9";
exports.palegoldenrod = "#EEE8AA";
exports.khaki = "#F0E68C";
exports.darkkhaki = "#BDB76B";
exports.lavender = "#E6E6FA";
exports.thistle = "#D8BFD8";
exports.plum = "#DDA0DD";
exports.violet = "#EE82EE";
exports.orchid = "#DA70D6";
exports.fuchsia = "#FF00FF";
exports.magenta = "#FF00FF";
exports.mediumorchid = "#BA55D3";
exports.mediumpurple = "#9370DB";
exports.blueviolet = "#8A2BE2";
exports.darkviolet = "#9400D3";
exports.darkorchid = "#9932CC";
exports.darkmagenta = "#8B008B";
exports.purple = "#800080";
exports.indigo = "#4B0082";
exports.slateblue = "#6A5ACD";
exports.darkslateblue = "#483D8B";
exports.mediumslateblue = "#7B68EE";
exports.greenyellow = "#ADFF2F";
exports.chartreuse = "#7FFF00";
exports.lawngreen = "#7CFC00";
exports.lime = "#00FF00";
exports.limegreen = "#32CD32";
exports.palegreen = "#98FB98";
exports.lightgreen = "#90EE90";
exports.mediumspringgreen = "#00FA9A";
exports.springgreen = "#00FF7F";
exports.mediumseagreen = "#3CB371";
exports.seagreen = "#2E8B57";
exports.forestgreen = "#228B22";
exports.green = "#008000";
exports.darkgreen = "#006400";
exports.yellowgreen = "#9ACD32";
exports.olivedrab = "#6B8E23";
exports.olive = "#808000";
exports.darkolivegreen = "#556B2F";
exports.mediumaquamarine = "#66CDAA";
exports.darkseagreen = "#8FBC8F";
exports.lightseagreen = "#20B2AA";
exports.darkcyan = "#008B8B";
exports.teal = "#008080";
exports.aqua = "#00FFFF";
exports.cyan = "#00FFFF";
exports.lightcyan = "#E0FFFF";
exports.paleturquoise = "#AFEEEE";
exports.aquamarine = "#7FFFD4";
exports.turquoise = "#40E0D0";
exports.mediumturquoise = "#48D1CC";
exports.darkturquoise = "#00CED1";
exports.cadetblue = "#5F9EA0";
exports.steelblue = "#4682B4";
exports.lightsteelblue = "#B0C4DE";
exports.powderblue = "#B0E0E6";
exports.lightblue = "#ADD8E6";
exports.skyblue = "#87CEEB";
exports.lightskyblue = "#87CEFA";
exports.deepskyblue = "#00BFFF";
exports.dodgerblue = "#1E90FF";
exports.cornflowerblue = "#6495ED";
exports.royalblue = "#4169E1";
exports.blue = "#0000FF";
exports.mediumblue = "#0000CD";
exports.darkblue = "#00008B";
exports.navy = "#000080";
exports.midnightblue = "#191970";
exports.cornsilk = "#FFF8DC";
exports.blanchedalmond = "#FFEBCD";
exports.bisque = "#FFE4C4";
exports.navajowhite = "#FFDEAD";
exports.wheat = "#F5DEB3";
exports.burlywood = "#DEB887";
exports.tan = "#D2B48C";
exports.rosybrown = "#BC8F8F";
exports.sandybrown = "#F4A460";
exports.goldenrod = "#DAA520";
exports.darkgoldenrod = "#B8860B";
exports.peru = "#CD853F";
exports.chocolate = "#D2691E";
exports.saddlebrown = "#8B4513";
exports.sienna = "#A0522D";
exports.brown = "#A52A2A";
exports.maroon = "#800000";
exports.white = "#FFFFFF";
exports.snow = "#FFFAFA";
exports.honeydew = "#F0FFF0";
exports.mintcream = "#F5FFFA";
exports.azure = "#F0FFFF";
exports.aliceblue = "#F0F8FF";
exports.ghostwhite = "#F8F8FF";
exports.whitesmoke = "#F5F5F5";
exports.seashell = "#FFF5EE";
exports.beige = "#F5F5DC";
exports.oldlace = "#FDF5E6";
exports.floralwhite = "#FFFAF0";
exports.ivory = "#FFFFF0";
exports.antiquewhite = "#FAEBD7";
exports.linen = "#FAF0E6";
exports.lavenderblush = "#FFF0F5";
exports.mistyrose = "#FFE4E1";
exports.gainsboro = "#DCDCDC";
exports.lightgray = "#D3D3D3";
exports.lightgrey = "#D3D3D3";
exports.silver = "#C0C0C0";
exports.darkgray = "#A9A9A9";
exports.darkgrey = "#A9A9A9";
exports.gray = "#808080";
exports.grey = "#808080";
exports.dimgray = "#696969";
exports.dimgrey = "#696969";
exports.lightslategray = "#778899";
exports.lightslategrey = "#778899";
exports.slategray = "#708090";
exports.slategrey = "#708090";
exports.darkslategray = "#2F4F4F";
exports.darkslategrey = "#2F4F4F";
exports.black = "#000000";
